import { createFileRoute } from '@tanstack/react-router';
import ScorecardPage from '../../views/dashboard-scorecard';

export const Route = createFileRoute('/dashboard/scorecard/')({
  component: ScorecardPage,
});
